module.exports = __webpack_public_path__ + "static/media/sunday_times_cropped.47bd91f3.png";